// src/components/SystemTray.js
// Fixed to the bottom of the viewport — always visible, not scrollable.
import React, { useEffect, useState, useCallback } from "react";

function getActiveDb() { return sessionStorage.getItem("active_db") || ""; }
function getUser() {
  try { return JSON.parse(sessionStorage.getItem("auth_user") || "null"); } catch { return null; }
}

export default function SystemTray() {
  const [dbId,       setDbId]       = useState(getActiveDb);
  const [user,       setUser]       = useState(getUser);
  const [status,     setStatus]     = useState("idle"); // idle | ok | error
  const [statusText, setStatusText] = useState("");

  // Re-read session on storage events (tab switches, login, db change)
  useEffect(() => {
    const handler = () => { setDbId(getActiveDb()); setUser(getUser()); };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  const ping = useCallback(async () => {
    if (!getActiveDb()) { setStatus("idle"); setStatusText(""); return; }
    const token = sessionStorage.getItem("auth_token") || "";
    try {
      const r = await fetch("/api/reports/health", {
        signal: AbortSignal.timeout(5000),
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (r.ok) { setStatus("ok"); setStatusText("Connected"); }
      else       { setStatus("error"); setStatusText(`Error ${r.status}`); }
    } catch {
      setStatus("error");
      setStatusText("Unreachable");
    }
  }, []);

  // Ping on mount and every 60 s
  useEffect(() => {
    ping();
    const t = setInterval(ping, 60000);
    return () => clearInterval(t);
  }, [ping]);

  const dotColor = status === "ok" ? "#22c55e" : status === "error" ? "#ef4444" : "#6b7280";
  const label    = dbId || "No database";

  return (
    <div className="sys-tray">
      <div className="sys-tray-inner">

        {/* DB status */}
        <div className="tray-seg">
          <span className="tray-dot" style={{ background: dotColor }} />
          <span className="tray-text" title={statusText || "No database selected"}>
            {label}
          </span>
          {statusText && (
            <span className="tray-badge" style={{
              color: status === "error" ? "#ef4444" : status === "ok" ? "#22c55e" : "#6b7280",
            }}>
              {statusText}
            </span>
          )}
        </div>

        <span className="tray-divider" />

        {/* Logged-in user */}
        {user && (
          <div className="tray-seg">
            <span className="tray-text" style={{ opacity: 0.7 }}>
              {user.label || user.username || user.email || "User"}
            </span>
          </div>
        )}

        {/* Future slot — leave gap for upcoming widgets */}
        <div style={{ flex: 1 }} />

        {/* Version / build slot */}
        <div className="tray-seg" style={{ opacity: 0.35 }}>
          <span className="tray-text" style={{ fontSize: 10 }}>IMS</span>
        </div>

      </div>
    </div>
  );
}
